import { render, staticRenderFns } from "./padlet_collection.vue?vue&type=template&id=422d0c7a&"
import script from "./padlet_collection.vue?vue&type=script&lang=js&"
export * from "./padlet_collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports